import { store } from "../store";// adjust this path to your Redux store location

export function getCombinedData() {
  const state = store.getState();
  return state.combinedata;
}

export function getZoneVerticesData() {
  return getCombinedData().ZoneVerticesData || [];
}

export function getAffiliateData() {
  return getCombinedData().AffiliateData || [];
}


export function getSelectedAffiliateId(selectedAffRef, propsSelectedAffiliates, affiliateData) {
    const selectedCompany = document.getElementsByClassName("form-select")[0]?.value || "";
    let selectedAffTemp = selectedAffRef?.current ? parseInt(selectedAffRef.current) : parseInt(propsSelectedAffiliates);
    
    if (selectedAffTemp === 0) {
        for (let i = 0; i < affiliateData.length; i++) {
            if (selectedCompany.includes(affiliateData[i].DTSPID.toString())) {
                selectedAffTemp = parseInt(affiliateData[i]["AffiliateID"]);
                break;
            }
        }
    }

    return selectedAffTemp;
}




